import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'
import * as componentStore from '../../../component-store'

@ngCore.Component({
  imports: [
    ds.input.text.Component,
    ds.input.code.Component,
    ngCommon.JsonPipe,
  ],
  selector: 'atn-page-configuration-query-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** @see {@link componentStore.configuration.Store} */
  public readonly store = ngCore.inject(componentStore.configuration.Store)

  /**
   * Updates {@link configuration.State.editingPageConfiguration} with changed query
   */
  public queryChangeHandler(query: unknown): void {
    // NOTE: we just hope the query is structured properly
    this.store.updateEditingPageConfiguration({
      query: query as ents.core.mosaic.Page.Query,
    })
  }
}
